/* Covano – theme.js. Geen libraries. */
(function () {
  'use strict';
  var P = window.Covano || {};
  var S = P.strings || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Geld ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || P.moneyFormat || '€{{amount_with_comma_separator}}';
    function fmt(n, prec, thou, dec) {
      thou = thou === undefined ? '.' : thou; dec = dec === undefined ? ',' : dec;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(prec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      var c = parts[1] ? dec + parts[1] : '';
      return d + c;
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/); var v = '';
    switch (m ? m[1] : 'amount_with_comma_separator') {
      case 'amount': v = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  P.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 2600);
  }

  /* ---------- Header-hoogte ---------- */
  function setHeaderH() {
    var h = $('.section-header');
    if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
  }
  setHeaderH();
  window.addEventListener('resize', setHeaderH);

  /* ---------- Lades ---------- */
  var overlay = $('[data-overlay]');
  var lastFocus = null;
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]'); if (!d) return;
    $$('[data-drawer].is-open').forEach(function (o) { if (o !== d) closeDrawer(o); });
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    var host = d.closest('.shopify-section, .section-header'); if (host) host.classList.add('is-raised');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); }
    document.body.classList.add('no-scroll');
    $$('[data-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = d.querySelector('[data-close]'); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer(d) {
    d = typeof d === 'string' ? $('[data-drawer="' + d + '"]') : d;
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    var host = d.closest('.shopify-section, .section-header'); if (host) setTimeout(function () { if (!host.querySelector('.drawer.is-open')) host.classList.remove('is-raised'); }, 260);
    $$('[data-open="' + d.getAttribute('data-drawer') + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!$('[data-drawer].is-open')) {
      if (overlay) { overlay.classList.remove('is-visible'); setTimeout(function () { if (!$('[data-drawer].is-open')) overlay.hidden = true; }, 200); }
      document.body.classList.remove('no-scroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }
  P.openDrawer = openDrawer;
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) {
      var name = o.getAttribute('data-open');
      if ($('[data-drawer="' + name + '"]')) {
        if (name === 'cart' && document.body.classList.contains('tpl-cart')) return;
        e.preventDefault(); openDrawer(name);
      }
      return;
    }
    var c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('[data-drawer]')); return; }
    if (e.target === overlay) $$('[data-drawer].is-open').forEach(closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('[data-drawer].is-open').forEach(closeDrawer);
      $$('.mainnav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
      var pr = $('[data-predictive-results]'); if (pr) pr.hidden = true;
    }
  });

  /* ---------- Aankondigingsbalk (alleen telefoon roteert) ---------- */
  $$('[data-rotator]').forEach(function (r) {
    var items = $$('.announce__item', r); if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Megamenu ---------- */
  $$('[data-mega-item].has-mega').forEach(function (item) {
    var t; var link = item.querySelector('.mainnav__link');
    function open() { clearTimeout(t); $$('.mainnav__item.is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); }); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }
    function close() { t = setTimeout(function () { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }, 140); }
    item.addEventListener('mouseenter', function () { t = setTimeout(open, 90); });
    item.addEventListener('mouseleave', function () { clearTimeout(t); close(); });
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
    link.addEventListener('touchstart', function (e) { if (!item.classList.contains('is-open')) { e.preventDefault(); open(); } }, { passive: false });
  });

  /* ---------- Voorspellend zoeken ---------- */
  $$('[data-predictive]').forEach(function (form) {
    var input = form.querySelector('input[type="search"]');
    var box = form.querySelector('[data-predictive-results]');
    if (!input || !box || !P.routes || !P.routes.predictive) return;
    var timer, ctrl;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = P.routes.predictive + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[limit]=6&resources[type]=product,query,collection&resources[options][fields]=title,vendor,product_type,variants.barcode,variants.sku';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('[data-predictive-content]');
          box.innerHTML = res ? res.innerHTML : '';
          box.hidden = !box.innerHTML.trim();
        }).catch(function () {});
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
    input.addEventListener('focus', function () { if (box.innerHTML.trim()) box.hidden = false; });
  });

  /* ---------- Verlanglijst ---------- */
  var WKEY = 'covano_wishlist';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function wishSet(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} }
  function wishSync() {
    var list = wishGet();
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wish')) > -1;
      b.classList.toggle('is-wished', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? S.wishUnsave : S.wishSave);
    });
    $$('[data-wishlist-count]').forEach(function (c) { c.textContent = list.length; c.hidden = list.length === 0; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-wish'); var list = wishGet(); var i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast(S.wishlistRemove); } else { list.unshift(h); toast(S.wishlistAdd); }
    wishSet(list.slice(0, 100)); wishSync();
    var grid = b.closest('[data-wishlist-grid]'); if (grid && i > -1) { var card = b.closest('.card'); if (card) card.remove(); if (!grid.children.length) renderWishlist(); }
  });
  wishSync(); P.wishSync = wishSync;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function renderWishlist() {
    var grid = $('[data-wishlist-grid]'); var empty = $('[data-wishlist-empty]');
    if (!grid) return;
    var list = wishGet();
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    Promise.all(list.map(function (h) {
      return fetch((P.routes.root || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      grid.innerHTML = items.filter(Boolean).map(function (p) {
        var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        var sale = p.compare_at_price && p.compare_at_price > p.price;
        var pct = sale ? Math.floor((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
        return '<div class="card">' +
          '<a class="card__media" href="' + esc(p.url) + '" tabindex="-1">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          (sale ? '<div class="card__badges"><span class="badge badge--sale">−' + pct + '%</span></div>' : '') +
          '<button class="card__heart is-wished" type="button" data-wish="' + esc(p.handle) + '" aria-pressed="true" aria-label="' + esc(S.wishUnsave) + '"><svg class="icon icon-heart" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.8-4.6-7.8-10.4A4.4 4.4 0 0 1 12 7.2a4.4 4.4 0 0 1 7.8 2.7c0 5.8-7.8 10.4-7.8 10.4Z" fill="currentColor" stroke="currentColor" stroke-width="1.7"/></svg></button>' +
          '<div class="card__body"><p class="card__brand">' + esc(p.vendor) + '</p><p class="card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></p>' +
          '<div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__now">' + formatMoney(p.price) + '</span>' + (sale ? '<s class="price__was">' + formatMoney(p.compare_at_price) + '</s>' : '') + '</div>' +
          (p.available ? '' : '<p class="card__meta">' + esc(S.soldOut) + '</p>') + '</div></div>';
      }).join('');
      var valid = items.filter(Boolean).map(function (p) { return p.handle; });
      if (valid.length !== list.length) { wishSet(valid); wishSync(); }
      if (!valid.length && empty) empty.hidden = false;
    });
  }
  renderWishlist();

  /* ---------- Winkelwagen ---------- */
  function updateCartFromSections(sections) {
    var html = sections && sections['cart-drawer']; if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    ['[data-cart-body]', '[data-cart-foot]'].forEach(function (sel) {
      var n = doc.querySelector(sel); var o = $(sel); if (n && o) o.innerHTML = n.innerHTML;
    });
    var title = doc.querySelector('.cart-drawer .drawer__title'); var ot = $('.cart-drawer .drawer__title'); if (title && ot) ot.innerHTML = title.innerHTML;
    var cnt = doc.querySelector('[data-cart-count-src]');
    if (cnt) $$('[data-cart-count]').forEach(function (c) { c.textContent = cnt.textContent; c.hidden = cnt.textContent.trim() === '0'; });
    runEta();
  }
  function cartChange(key, qty) {
    var body = $('[data-cart-body]'); if (body) body.classList.add('is-loading');
    return fetch(P.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (document.body.classList.contains('tpl-cart')) { window.location.reload(); return; }
      if (data.status && data.description) toast(data.description);
      updateCartFromSections(data.sections);
    }).catch(function () { toast(S.error); }).finally(function () { if (body) body.classList.remove('is-loading'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-change]'); if (!b) return;
    e.preventDefault(); cartChange(b.getAttribute('data-key'), parseInt(b.getAttribute('data-qty-change'), 10));
  });

  /* ---------- Productformulier ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]'); if (!form) return;
    e.preventDefault();
    var pdp = form.closest('[data-pdp]');
    if (pdp && pdp._needsSize && pdp._needsSize()) return;
    var btn = form.querySelector('[type="submit"]'); var msg = form.querySelector('[data-atc-msg]');
    if (btn) btn.classList.add('is-loading');
    if (msg) msg.textContent = '';
    var fd = new FormData(form); fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname);
    fetch(P.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { if (msg) msg.textContent = data.description || data.message || S.error; return; }
        updateCartFromSections(data.sections); openDrawer('cart');
      }).catch(function () { if (msg) msg.textContent = S.error; })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- Footer: op telefoon ingeklapt ---------- */
  if (!window.matchMedia('(min-width: 990px)').matches) $$('details.footer__col').forEach(function (d) { d.open = false; });

  /* ---------- Rij-pijlen ---------- */
  $$('[data-scroller-nav]').forEach(function (nav) {
    var sc = document.getElementById(nav.getAttribute('data-scroller-nav')); if (!sc) return;
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var dir = b.hasAttribute('data-next') ? 1 : -1;
      sc.scrollBy({ left: dir * sc.clientWidth * 0.9, behavior: 'smooth' });
    });
  });

  /* ---------- Bezorgdatum ---------- */
  function amsNow() {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
    var p = {}; f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, min: +p.minute };
  }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
      h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(y, month - 1, day));
  }
  var holCache = {};
  function holidays(y, cc) {
    var k = y + cc; if (holCache[k]) return holCache[k];
    var e = easter(y); var add = function (n) { var d = new Date(e); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
    var p = function (m, d) { return y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d; };
    var list = [p(1, 1), add(1), add(39), add(50), p(12, 25)];
    if (cc === 'nl') { list.push(p(12, 26)); var kd = new Date(Date.UTC(y, 3, 27)); if (kd.getUTCDay() === 0) kd.setUTCDate(26); list.push(kd.toISOString().slice(0, 10)); }
    if (cc === 'be') { list.push(p(5, 1), p(7, 21), p(8, 15), p(11, 1), p(11, 11)); }
    holCache[k] = list; return list;
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function isShipDay(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && holidays(d.getUTCFullYear(), 'nl').indexOf(iso(d)) === -1; }
  function isDeliveryDay(d, cc) { var w = d.getUTCDay(); if (w === 0) return false; if (w === 6 && !(P.delivery && P.delivery.saturday)) return false; return holidays(d.getUTCFullYear(), cc).indexOf(iso(d)) === -1; }
  function deliveryInfo(cc) {
    var n = amsNow(); var cut = ((P.delivery && P.delivery.cutoff) || '22:00').split(':');
    var ch = parseInt(cut[0], 10) || 22, cm = parseInt(cut[1], 10) || 0;
    var today = new Date(Date.UTC(n.y, n.m - 1, n.d));
    var ship = new Date(today); var shipsToday = isShipDay(today) && (n.h * 60 + n.min) < (ch * 60 + cm);
    if (!shipsToday) { do { ship.setUTCDate(ship.getUTCDate() + 1); } while (!isShipDay(ship)); }
    var days = (P.delivery && P.delivery[cc]) || (cc === 'nl' ? 1 : 2);
    var del = new Date(ship); var c = 0;
    while (c < days) { del.setUTCDate(del.getUTCDate() + 1); if (isDeliveryDay(del, cc)) c++; }
    var diff = Math.round((del - today) / 86400000);
    var left = shipsToday ? (ch * 60 + cm) - (n.h * 60 + n.min) : 0;
    return { date: del, diff: diff, left: left };
  }
  function fmtDate(d) {
    var loc = (P.locale || 'nl') === 'fr' ? 'fr-BE' : 'nl-NL';
    return new Intl.DateTimeFormat(loc, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(d);
  }
  function label(info) { return info.diff === 1 ? S.tomorrow : fmtDate(info.date); }
  function runEta() {
    $$('[data-eta]').forEach(function (el) {
      var nl = deliveryInfo('nl'), be = deliveryInfo('be');
      var a = el.querySelector('[data-eta-nl]'); if (a) a.textContent = label(nl);
      var b = el.querySelector('[data-eta-be]'); if (b) b.textContent = label(be);
      var cd = el.querySelector('[data-eta-cut]');
      if (cd) {
        if (nl.left > 0 && nl.left <= 720) {
          var h = Math.floor(nl.left / 60), m = nl.left % 60;
          cd.textContent = S.orderWithin.replace('{time}', (h ? h + ' ' + S.hours + ' ' : '') + m + ' ' + S.minutes);
          cd.hidden = false;
        } else cd.hidden = true;
      }
    });
    $$('[data-eta-short] span').forEach(function (s) {
      var nl = deliveryInfo('nl');
      s.textContent = S.expectedNl.replace('{date}', nl.diff === 1 ? S.tomorrow : fmtDate(nl.date));
    });
  }
  runEta(); setInterval(runEta, 60000);

  /* ---------- Productpagina ---------- */
  $$('[data-pdp]').forEach(function (pdp) {
    var dataEl = pdp.querySelector('[data-variants]'); if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || []; var sizeIdx = data.sizeIndex; var colorIdx = data.colorIndex;
    var form = pdp.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('[name="id"]');
    var btn = form && form.querySelector('[data-atc]');
    var stickyBtn = pdp.querySelector('[data-sticky-atc] button');
    var msg = form && form.querySelector('[data-atc-msg]');
    var priceEl = pdp.querySelector('[data-price]');
    var stickyPrice = pdp.querySelector('[data-sticky-price]');
    var stock = pdp.querySelector('[data-stock]');
    var saveEl = pdp.querySelector('[data-save]');

    function selected() {
      var opts = [];
      $$('[data-option-index]', pdp).forEach(function (g) {
        var i = +g.getAttribute('data-option-index');
        var c = g.querySelector('input:checked'); var s = g.querySelector('select');
        opts[i] = c ? c.value : (s ? s.value : null);
      });
      return opts;
    }
    function find(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }) && opts.length === v.options.length && opts.every(function (o) { return o != null; }); });
    }
    function availFor(i, val, opts) {
      return variants.some(function (v) { return v.available && v.options[i] === val && v.options.every(function (o, j) { return j === i || opts[j] == null || o === opts[j]; }); });
    }
    function lowFor(i, val, opts) {
      var v = variants.find(function (v) { return v.options[i] === val && v.options.every(function (o, j) { return j === i || opts[j] == null || o === opts[j]; }); });
      return v && v.tracked && v.available && v.qty > 0 && v.qty <= P.stockThreshold ? v.qty : 0;
    }
    function priceHTML(v) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      return '<div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__now">' + formatMoney(v.price) + '</span>' +
        (sale ? '<s class="price__was"><span class="visually-hidden">' + esc(data.wasLabel) + '</span>' + formatMoney(v.compare_at_price) + '</s>' : '') +
        (v.unit ? '<span class="price__unit">' + esc(v.unit) + '</span>' : '') + '</div>';
    }
    function update(push) {
      var opts = selected();
      // Beschikbaarheid per optie
      $$('[data-option-index]', pdp).forEach(function (g) {
        var i = +g.getAttribute('data-option-index');
        $$('input', g).forEach(function (inp) {
          var wrap = inp.closest('.size, .swatch'); if (!wrap) return;
          var ok = availFor(i, inp.value, opts);
          wrap.classList.toggle('is-unavailable', !ok);
          
        });
        var cur = g.querySelector('[data-current]'); var chk = g.querySelector('input:checked'); if (cur) cur.textContent = chk ? (chk.getAttribute('data-short') || chk.value) : '';
      });
      var v = find(opts);
      var sizePending = sizeIdx != null && opts[sizeIdx] == null;
      if (!v && sizePending) {
        // Toon prijs van eerste variant in deze kleur
        var any = variants.find(function (x) { return colorIdx == null || x.options[colorIdx] === opts[colorIdx]; }) || variants[0];
        if (priceEl && any) priceEl.innerHTML = priceHTML(any);
        if (btn) { btn.disabled = false; btn.textContent = S.addToCart; }
        if (stickyBtn) stickyBtn.textContent = S.chooseSize;
        if (stock) stock.hidden = true;
        if (saveEl) setSave(any);
        return;
      }
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = S.unavailable; }
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = S.unavailable; }
        if (stock) stock.hidden = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = priceHTML(v);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (saveEl) setSave(v);
      var label = v.available ? S.addToCart : S.soldOut;
      if (btn) { btn.disabled = !v.available; btn.textContent = label; }
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = label; }
      if (msg) msg.textContent = '';
      if (stock) {
        stock.className = 'stock'; stock.hidden = false;
        if (!v.available) { stock.classList.add('stock--out'); stock.textContent = S.soldOut; }
        else if (v.tracked && v.qty > 0 && v.qty <= P.stockThreshold) { stock.classList.add('stock--low'); stock.textContent = S.stockLow.replace('{count}', v.qty); }
        else if (v.tracked && v.qty <= 0 && v.policy === 'continue') { stock.classList.add('stock--low'); stock.textContent = S.backorder; }
        else { stock.classList.add('stock--ok'); stock.textContent = S.inStock; }
      }
      if (v.media && push !== false) goToMedia(v.media);
      if (push !== false && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }
    function setSave(v) {
      if (v && v.compare_at_price > v.price) {
        var diff = v.compare_at_price - v.price; var pct = Math.floor(diff * 100 / v.compare_at_price);
        saveEl.textContent = data.saveLabel.replace('{amount}', formatMoney(diff)).replace('{percent}', pct); saveEl.hidden = false;
      } else saveEl.hidden = true;
    }
    pdp._needsSize = function () {
      var opts = selected();
      if (sizeIdx != null && opts[sizeIdx] == null) {
        if (msg) msg.textContent = S.chooseSize;
        var g = pdp.querySelector('[data-option-index="' + sizeIdx + '"]');
        if (g) { g.scrollIntoView({ behavior: 'smooth', block: 'center' }); g.classList.add('is-attention'); setTimeout(function () { g.classList.remove('is-attention'); }, 1200); }
        return true;
      }
      return false;
    };
    pdp.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) update(); });
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (pdp._needsSize()) return;
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });

    // Galerij
    var strip = pdp.querySelector('[data-strip]');
    var count = pdp.querySelector('[data-count]');
    var thumbs = $$('[data-thumb]', pdp);
    var dots = $$('[data-dot]', pdp);
    var slides = strip ? $$('[data-slide]', strip) : [];
    function current() { return strip ? Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth)) : 0; }
    function mark() {
      var i = current();
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function go(i) { if (!strip) return; i = Math.max(0, Math.min(slides.length - 1, i)); strip.scrollTo({ left: i * strip.clientWidth, behavior: 'smooth' }); }
    function goToMedia(id) { var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == String(id); }); if (idx > -1) go(idx); }
    if (strip) {
      var raf; strip.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
      var prev = pdp.querySelector('[data-prev]'), next = pdp.querySelector('[data-next-slide]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      strip.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(current() + 1); if (e.key === 'ArrowLeft') go(current() - 1); });
      mark();
    }

    // Vaste koopbalk
    var sticky = pdp.querySelector('[data-sticky-atc]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0]; sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(btn);
    }
    update(false);
  });

  /* ---------- Filters ---------- */
  $$('[data-filter-form]').forEach(function (form) {
    var t;
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;
      clearTimeout(t); t = setTimeout(function () { submitFilters(form); }, 250);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submitFilters(form); });
  });
  function submitFilters(form) {
    var fd = new FormData(form); var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var sort = $('[data-sort]'); if (sort && sort.value) params.set('sort_by', sort.value);
    window.location.search = params.toString();
  }
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString();
    });
  });
})();
